import _Cascader from './Cascader';
import _CascaderPanel from './CascaderPanel';

import './style/index.js';

export type { CascaderProps } from './Cascader';
export * from './type';

export const Cascader = _Cascader;
export const CascaderPanel = _CascaderPanel;
export default Cascader;
